var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 69,
    viewBox: "0 0 67 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6901",
    "data-name": "Group 6901",
    transform: "translate(0 -113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1434",
    "data-name": "Rectangle 1434",
    transform: "translate(0 113)",
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 69,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 64,
    height: 66,
    rx: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user_3_",
    "data-name": "user (3)",
    transform: "translate(8.698 126.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6787",
    "data-name": "Group 6787",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15041",
    "data-name": "Path 15041",
    d: "M42.339,32.066a24.706,24.706,0,0,0-9.425-5.911,14.338,14.338,0,1,0-16.225,0A24.841,24.841,0,0,0,0,49.6H3.875a20.926,20.926,0,1,1,41.853,0H49.6A24.64,24.64,0,0,0,42.339,32.066ZM24.8,24.8A10.463,10.463,0,1,1,35.265,14.338,10.475,10.475,0,0,1,24.8,24.8Z",
    transform: "translate(0 -2)",
    fill: "#ddd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfil);
export default __webpack_public_path__ + "static/media/icon-profil.54822c26.svg";
export { ForwardRef as ReactComponent };